// Sample responses from the API

export const sampleData = [
  {data: {
    "title": "MobilizeAmerica Canvass Training",
    "approval_status": "APPROVED",
    "tags": [],
    "sponsor": {
      "state": "",
      "race_type": null,
      "slug": "mobilize",
      "event_feed_url": "https://www.mobilize.us/",
      "is_coordinated": true,
      "is_independent": false,
      "id": 12312311,
      "candidate_name": "",
      "org_type": "CAMPAIGN",
      "is_primary_campaign": false,
      "created_date": 1511902789,
      "modified_date": 1601487203,
      "district": "",
      "name": "Mobilize"
    },
    "is_virtual": true,
    "description": "Sharpen your canvass skills with our professional organizers",
    "featured_image_url": "https://mobilizeamerica.imgix.net/uploads/event/DXJ5lJRU0AEzf0p_20180305030842825057.jpg",
    "contact": null,
    "timeslots": [
      {
        "id": 1,
        "is_full": false,
        "instructions": null,
        "end_date": 1513432800,
        "start_date": 1513425600
      }
    ],
    "accessibility_status": null,
    "high_priority": null,
    "created_date": 1511904228,
    "browser_url": "https://www.mobilize.us/mobilize/event/1/",
    "timezone": "America/New_York",
    "accessibility_notes": null,
    "visibility": "PUBLIC",
    "virtual_action_url": null,
    "summary": "Sharpen your canvass skills with our professional organizers",
    "address_visibility": "PUBLIC",
    "created_by_volunteer_host": false,
    "location": {
      "venue": "Cherrywood Coffeehouse",
      "address_lines": [
        "1400 E 38th 1/2 St.",
        ""
      ],
      "locality": "Austin",
      "region": "TX",
      "country": "US",
      "postal_code": "78702",
      "location": {
        "latitude": 30.2935421,
        "longitude": -97.716
      },
      "congressional_district": null,
      "state_leg_district": null,
      "state_senate_district": null
    },
    "event_campaign": null,
    "event_type": "MEETING",
    "id": 1123123,
    "instructions": null,
    "modified_date": 1600118991
  }},
  {data: {
    "title": "MobilizeAmerica & Town Hall Project Onboarding Call",
    "approval_status": "APPROVED",
    "tags": [],
    "sponsor": {
      "state": "",
      "race_type": null,
      "slug": "mobilize",
      "event_feed_url": "https://www.mobilize.us/",
      "is_coordinated": true,
      "is_independent": false,
      "id": 1123123,
      "candidate_name": "",
      "org_type": "CAMPAIGN",
      "is_primary_campaign": false,
      "created_date": 1511902789,
      "modified_date": 1601487203,
      "district": "",
      "name": "Mobilize"
    },
    "is_virtual": true,
    "description": "After signing up here, you will receive an email to register for our conference call. We will be joined by the team at the Town Hall Project to discuss how you can get involved researching town hall events for state legislatures across the country. All are welcome!",
    "featured_image_url": "https://mobilizeamerica.imgix.net/uploads/event/DXJ5lJRU0AEzf0p_20180305030842825057.jpg",
    "contact": null,
    "timeslots": [
      {
        "id": 5123123,
        "is_full": false,
        "instructions": null,
        "end_date": 1513130400,
        "start_date": 1513123200
      }
    ],
    "accessibility_status": null,
    "high_priority": null,
    "created_date": 1512507497,
    "browser_url": "https://www.mobilize.us/mobilize/event/4/",
    "timezone": "America/New_York",
    "accessibility_notes": null,
    "visibility": "PUBLIC",
    "virtual_action_url": null,
    "summary": "Join us to learn more about researching town halls for state legislatures across the country",
    "address_visibility": "PUBLIC",
    "created_by_volunteer_host": false,
    "location": {
      "venue": "Cherrywood Coffeehouse",
      "address_lines": [
        "1400 E 38th 1/2 St.",
        ""
      ],
      "locality": "Austin",
      "region": "TX",
      "country": "US",
      "postal_code": "78702",
      "location": {
        "latitude": 30.2935421,
        "longitude": -97.716
      },
      "congressional_district": null,
      "state_leg_district": null,
      "state_senate_district": null
    },
    "event_campaign": null,
    "event_type": "MEETING",
    "id": 412312,
    "instructions": null,
    "modified_date": 1600119407
  }},
  {data: {
    "title": "Open Enrollment Training for Calls and Texts",
    "approval_status": "APPROVED",
    "tags": [],
    "sponsor": {
      "state": "",
      "race_type": null,
      "slug": "mobilize",
      "event_feed_url": "https://www.mobilize.us/",
      "is_coordinated": true,
      "is_independent": false,
      "id": 1231231,
      "candidate_name": "",
      "org_type": "CAMPAIGN",
      "is_primary_campaign": false,
      "created_date": 1511902789,
      "modified_date": 1601487203,
      "district": "",
      "name": "Mobilize"
    },
    "is_virtual": true,
    "description": "Join Spencer Dixon and Young Invincibles to hear more about calling and texting people to get them the resources they need to enroll in healthcare before the December 15 deadline.",
    "featured_image_url": "https://mobilizeamerica.imgix.net/uploads/event/DXJ5lJRU0AEzf0p_20180305030842825057.jpg",
    "contact": null,
    "timeslots": [
      {
        "id": 6,
        "is_full": false,
        "instructions": null,
        "end_date": 1512766800,
        "start_date": 1512759600
      }
    ],
    "accessibility_status": null,
    "high_priority": null,
    "created_date": 1512682732,
    "browser_url": "https://www.mobilize.us/mobilize/event/5/",
    "timezone": "America/New_York",
    "accessibility_notes": null,
    "visibility": "PUBLIC",
    "virtual_action_url": null,
    "summary": "",
    "address_visibility": "PUBLIC",
    "created_by_volunteer_host": false,
    "location": {
      "venue": "Cherrywood Coffeehouse",
      "address_lines": [
        "1400 E 38th 1/2 St.",
        ""
      ],
      "locality": "Austin",
      "region": "TX",
      "country": "US",
      "postal_code": "78702",
      "location": {
        "latitude": 30.2935421,
        "longitude": -97.716
      },
      "congressional_district": null,
      "state_leg_district": null,
      "state_senate_district": null
    },
    "event_campaign": null,
    "event_type": "MEETING",
    "id": 51231,
    "instructions": null,
    "modified_date": 1600119817
  }},
  {data: {
    "title": "Texting for the Open Enrollment Deadline",
    "approval_status": "APPROVED",
    "tags": [],
    "sponsor": {
      "state": "",
      "race_type": null,
      "slug": "mobilize",
      "event_feed_url": "https://www.mobilize.us/",
      "is_coordinated": true,
      "is_independent": false,
      "id": 145643,
      "candidate_name": "",
      "org_type": "CAMPAIGN",
      "is_primary_campaign": false,
      "created_date": 1511902789,
      "modified_date": 1601487203,
      "district": "",
      "name": "Mobilize"
    },
    "is_virtual": true,
    "description": "Help people interested in signing up for the ACA get the resources they need by texting a list on GroundGame! Make sure to also call into our training to find out more!",
    "featured_image_url": "https://mobilizeamerica.imgix.net/uploads/event/DXJ5lJRU0AEzf0p_20180305030842825057.jpg",
    "contact": null,
    "timeslots": [
      {
        "id": 7,
        "is_full": false,
        "instructions": null,
        "end_date": 1512784800,
        "start_date": 1512741600
      },
      {
        "id": 8,
        "is_full": false,
        "instructions": null,
        "end_date": 1512871200,
        "start_date": 1512828000
      },
      {
        "id": 9,
        "is_full": false,
        "instructions": null,
        "end_date": 1512957600,
        "start_date": 1512914400
      },
      {
        "id": 10,
        "is_full": false,
        "instructions": null,
        "end_date": 1513044000,
        "start_date": 1513000800
      },
      {
        "id": 11,
        "is_full": false,
        "instructions": null,
        "end_date": 1513130400,
        "start_date": 1513087200
      },
      {
        "id": 12,
        "is_full": false,
        "instructions": null,
        "end_date": 1513216800,
        "start_date": 1513173600
      },
      {
        "id": 13,
        "is_full": false,
        "instructions": null,
        "end_date": 1513303200,
        "start_date": 1513260000
      },
      {
        "id": 14,
        "is_full": false,
        "instructions": null,
        "end_date": 1513389600,
        "start_date": 1513346400
      }
    ],
    "accessibility_status": null,
    "high_priority": null,
    "created_date": 1512683348,
    "browser_url": "https://www.mobilize.us/mobilize/event/6/",
    "timezone": "America/New_York",
    "accessibility_notes": null,
    "visibility": "PUBLIC",
    "virtual_action_url": null,
    "summary": "",
    "address_visibility": "PUBLIC",
    "created_by_volunteer_host": false,
    "location": {
      "venue": "Cherrywood Coffeehouse",
      "address_lines": [
        "1400 E 38th 1/2 St.",
        ""
      ],
      "locality": "Austin",
      "region": "TX",
      "country": "US",
      "postal_code": "78702",
      "location": {
        "latitude": 30.2935421,
        "longitude": -97.716
      },
      "congressional_district": null,
      "state_leg_district": null,
      "state_senate_district": null
    },
    "event_campaign": null,
    "event_type": "TEXT_BANK",
    "id": 6123123,
    "instructions": null,
    "modified_date": 1600117847
  }},
  {data: {
    "title": "Cherrywood Neighborhood: Canvass for Julie!",
    "approval_status": "APPROVED",
    "tags": [],
    "sponsor": {
      "state": "TX",
      "race_type": "CONGRESSIONAL",
      "slug": "julieoliverforcongress",
      "event_feed_url": "https://www.mobilize.us/julieoliverforcongress/",
      "is_coordinated": true,
      "is_independent": false,
      "id": 1512312,
      "candidate_name": "Julie Oliver",
      "org_type": "CAMPAIGN",
      "is_primary_campaign": false,
      "created_date": 1515604602,
      "modified_date": 1601329106,
      "district": "25",
      "name": "Julie Oliver for Congress"
    },
    "is_virtual": false,
    "description": "Come and meet us at the Cherrywood Coffeehouse in Austin Texas!\n\nMake a difference while having fun! Just bring your phone all charged up and we'll take care of the rest!",
    "featured_image_url": "https://mobilizeamerica.imgix.net/uploads/event/DXJ5lJRU0AEzf0p_20180305030842825057.jpg",
    "contact": null,
    "timeslots": [
      {
        "id": 631,
        "is_full": false,
        "instructions": null,
        "end_date": 1518645600,
        "start_date": 1518624000
      },
      {
        "id": 754,
        "is_full": false,
        "instructions": null,
        "end_date": 1518732000,
        "start_date": 1518710400
      },
      {
        "id": 755,
        "is_full": false,
        "instructions": null,
        "end_date": 1518818400,
        "start_date": 1518796800
      },
      {
        "id": 756,
        "is_full": false,
        "instructions": null,
        "end_date": 1518904800,
        "start_date": 1518883200
      },
      {
        "id": 757,
        "is_full": false,
        "instructions": null,
        "end_date": 1518991200,
        "start_date": 1518969600
      },
      {
        "id": 843,
        "is_full": false,
        "instructions": null,
        "end_date": 1519077600,
        "start_date": 1519056000
      },
      {
        "id": 844,
        "is_full": false,
        "instructions": null,
        "end_date": 1519164000,
        "start_date": 1519142400
      },
      {
        "id": 845,
        "is_full": false,
        "instructions": null,
        "end_date": 1519250400,
        "start_date": 1519228800
      },
      {
        "id": 846,
        "is_full": false,
        "instructions": null,
        "end_date": 1519336800,
        "start_date": 1519315200
      },
      {
        "id": 847,
        "is_full": false,
        "instructions": null,
        "end_date": 1519423200,
        "start_date": 1519401600
      },
      {
        "id": 848,
        "is_full": false,
        "instructions": null,
        "end_date": 1519509600,
        "start_date": 1519488000
      },
      {
        "id": 849,
        "is_full": false,
        "instructions": null,
        "end_date": 1519596000,
        "start_date": 1519574400
      },
      {
        "id": 1636,
        "is_full": false,
        "instructions": null,
        "end_date": 1519603200,
        "start_date": 1519588800
      },
      {
        "id": 1637,
        "is_full": false,
        "instructions": null,
        "end_date": 1519689600,
        "start_date": 1519660800
      }
    ],
    "accessibility_status": null,
    "high_priority": null,
    "created_date": 1515719207,
    "browser_url": "https://www.mobilize.us/julieoliverforcongress/event/26/",
    "timezone": "America/Chicago",
    "accessibility_notes": null,
    "visibility": "PUBLIC",
    "virtual_action_url": null,
    "summary": "Canvass for Julie!",
    "address_visibility": "PUBLIC",
    "created_by_volunteer_host": false,
    "location": {
      "venue": "Cherrywood Coffeehouse",
      "address_lines": [
        "1400 E 38th 1/2 St.",
        ""
      ],
      "locality": "Austin",
      "region": "TX",
      "country": "US",
      "postal_code": "78702",
      "location": {
        "latitude": 30.2935421,
        "longitude": -97.716
      },
      "congressional_district": null,
      "state_leg_district": null,
      "state_senate_district": null
    },
    "event_campaign": null,
    "event_type": "CANVASS",
    "id": 2123126,
    "instructions": null,
    "modified_date": 1600119407
  }}
]
